import { memo, useEffect, useRef, useState, forwardRef } from 'react';
import { createPortal } from 'react-dom';
import cx from 'classnames';
import { CloseIcon } from "./icons";
import {
  OverlayBg, Action, Button, CloseBtn
} from '../styles/styles.js';

const Modal = ({ id, children, size, text, button, closeButton, customCloseText, ctaLabel, modalOpen }) => {

  const el = useRef(
    document.getElementById(id) || document.createElement('div'),
  );

  const [dynamic] = useState(!el.current.parentElement);
  const closeModal = () => {
    modalOpen(false);
    el.current.parentElement.removeChild(el.current);
    // el.current.style.display = 'none';
  }

  useEffect(() => {
    if (dynamic) {
      // if element exists, set id to new id
      el.current.id = id;
      document.body.appendChild(el.current);
    }
    return () => {
      if (dynamic && el.current.parentElement) {
        el.current.parentElement.removeChild(el.current);
      }
    };
  }, [id]);

  return createPortal(
    <OverlayBg size={size} className={cx({ 'loader': size === 'loading' })}>
      {size !== 'loading' && <div className="modalContent" tabIndex="0" aria-modal="true" aria-label={id} data-cta={ctaLabel}>
        <CloseBtn tabIndex="0" className="small" onClick={closeModal}><CloseIcon /></CloseBtn>
        {children ? children : <p dangerouslySetInnerHTML={{ __html: text }}></p>}
        <Action className="center nowrap">
          {closeButton && <Button className="outline inline" onClick={closeModal}>{customCloseText ? customCloseText : 'Ok'}</Button>}
          {button}
        </Action>
      </div>}
      {size === 'loading' && children}
    </OverlayBg>, el.current);
}

// const forwardedModal = forwardRef(Modal);

export default memo(Modal);
